module.exports = __webpack_public_path__ + "static/media/candy-cane.fcf68615.svg";